<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true" class="filter-form">
            <el-form-item label="客户姓名：">
              <el-input v-model="query.realName" placeholder="请输入客户姓名" clearable size="small" style="width: 160px;"></el-input>
            </el-form-item>
            <el-form-item label="客户电话：">
              <el-input v-model="query.phone" placeholder="请输入客户电话" clearable size="small" style="width: 160px;"></el-input>
            </el-form-item>
            <el-form-item label="区域：">
              <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small" style="width: 200px;"></el-cascader>
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.customerLevelId" placeholder="请选择" clearable size="small" style="width: 140px;">
                <el-option :label="item.name" :value="item.level" v-for="(item,index) in businessOption" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="客户信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.realName }}</span>
                <span style="display: block;">{{ row.phone }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用友编码" prop="yyCode" align="center"></el-table-column>
          <el-table-column label="身份" prop="identity" align="center"></el-table-column>
          <el-table-column label="所属区域" prop="area" align="center">
            <template slot-scope="{row}">
              {{row.addrProvince}}{{row.addrCity}}{{row.addrArea}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="总订单数" prop="order" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;">{{ row.order }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付总原价" prop="orderOldPrice" sortable="custom" align="center"></el-table-column> -->
          <!-- <el-table-column label="支付总价" prop="orderPrice" sortable="custom" align="center"></el-table-column>
          <el-table-column label="订货数" prop="dhNum" sortable="custom" align="center"></el-table-column> -->
          <el-table-column label="订货数" prop="orderTotalNum" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.orderTotalNum }}</span>
              <el-button type="primary" size="mini" @click="toPages(row.realName,1)">订货明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="余额/现金支付总价" prop="payBOCTotalAmount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="零售价支付总价" prop="payXDBTotalAmount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="赠送支付总价" prop="payGiveTotalAmount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="秒杀数" prop="seckillNum" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.seckillNum }}</span>
              <el-button type="primary" size="mini" @click="toPages(row.realName,3)">订货明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="秒杀支付总价" prop="seckillTotalAmount" sortable="custom" align="center" width="140"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'
import customerLevelApi from '@/api/sys/customerLevel'
import sysAddrApi from '@/api/sys/sysAddr'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        orderTotalNumSortSign: -1
        // isDisplay: 1,
        // keyword:'',
        // identity:''
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true,
      },
      selectItems: [],
      times: null,
      businessOption: [],
      navIndex: 0,
      addressList: [],
      today: ''
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getBusinessStanding()
    this.getOption()
    this.getAddressList()
  },
  methods: {
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取客户
    getOption() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    toPages(name, type) {
      let { timeStart, timeEnd } = this.times;
      this.$router.push({ path: '/order/goodsorder', query: { 'type': type, 'name': name, 'startTime': timeStart, 'endTime': timeEnd } })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'orderTotalNum': 'orderTotalNumSortSign',
        'payBOCTotalAmount': 'payBOCTotalAmountSortSign',
        'payXDBTotalAmount': 'payXDBTotalAmountSortSign',
        'payGiveTotalAmount': 'payGiveTotalAmountSortSign',
        'seckillNum': 'seckillNumSortSign',
        'seckillTotalAmount': 'seckillTotalAmountSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        // startIndex: 1,
        pageSize: 10,
        orderTotalNumSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    // changeNav(index) {
    //     this.navIndex = index;
    //     this.doQueryList({ pageNo: 1 });
    // },
    /**
     * 触发导出
     */
    handleDownload() {
      this.$router.push("/export/list?code=NaHuoStatisticsExportExcel")
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      console.log('addrid', this.query.addrid)
      let query = { ...this.query, parentId: this.id }
      if (this.navIndex) {
        query.customerLevelId = this.businessOption[this.navIndex].id
      }
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      if (this.query.addrid && this.query.addrid.length) {
        query.provinceCode = query.addrid[0]
        if (query.addrid.length > 1) {
          query.cityCode = query.addrid[1]
        }
        if (query.addrid.length > 2) {
          query.areaCode = query.addrid[2]
        }
        delete query.addrid
      }
      this.listLoading = true
      return goodsOrderApi.getNaHuoStatisticsList(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    // changeSwitch(row) {
    //   sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 页面跳转
     */
    toPage(path, row, type) {
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}`)
      } else {
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.nav-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
    white-space: nowrap;
  }
  .filter-form {
    ::v-deep .el-form-item {
      margin-right: 12px;
    }
  }
}
</style>
